import React from "react";

import {
  Box,
  Button,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";

import CautionIcon from "assets/images/icons/caution_circle.svg";
import ClosableDialog from "components/shared/ClosableDialog";

interface IUnpublishConfirmDialogProps {
  open: boolean;
  setOpen: Function;
  designs: string[];
  onConfirm: (isConfirmed: boolean) => void;
}

export const UnpublishConfirmDialog: React.FC<IUnpublishConfirmDialogProps> = ({
  open,
  setOpen,
  designs,
  onConfirm,
}) => (
  <ClosableDialog open={open} onClose={() => setOpen(false)}>
    <DialogContent>
      <Grid container direction="column" alignItems="center" spacing={3}>
        <Grid item>
          <Typography variant="h2">Alert</Typography>
        </Grid>
        <Grid item>
          <img src={CautionIcon} alt="Caution Icon" />
        </Grid>
        <Grid item>
          <Box mx={2}>
            <Typography align="center">
              Previous versions of the following designs will be unpublished and
              replaced with a new version:
            </Typography>
            <Box my={3}>
              <Typography align="center">{designs.join(",")}</Typography>
            </Box>
            <Typography align="center">
              Please confirm that you want to publish these designs.
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box display="flex" justifyContent="center" style={{ gap: 16 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onConfirm(true)}
            >
              Continue to publish
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => onConfirm(false)}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>
    </DialogContent>
  </ClosableDialog>
);
